import { useEffect, useRef } from 'react';

// 让滚动容器的滚动条「仅在滚动时显示」：滚动时给元素加 .is-scrolling,停止 ~700ms 后移除。
// 配合 global.css 的 .ml-thin-scroll(默认透明,.is-scrolling/悬停时淡入)使用。
export function useAutoHideScroll<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let timer: ReturnType<typeof setTimeout>;
    const onScroll = () => {
      el.classList.add('is-scrolling');
      clearTimeout(timer);
      timer = setTimeout(() => el.classList.remove('is-scrolling'), 700);
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => { el.removeEventListener('scroll', onScroll); clearTimeout(timer); };
  }, []);
  return ref;
}
